import React from 'react';

import { parseISO, format } from 'date-fns';

const DrivingSchool = ({driving_school, start_date, end_date, series}) => {
  const date_start = parseISO(start_date);
  const date_end = parseISO(end_date);
  return (
    <div className="column is-4">
      <div className="box">
        <h5 className="title is-5">{driving_school}</h5>
        <p>{series} séries</p>
        <p>Disponible du {format(date_start, "dd/MM/yyyy")} au {format(date_end, "dd/MM/yyyy")}</p>
      </div>
    </div>
  )
}

const DrivingSchools = ({drivingSchools}) => {
  return (
    <div className="columns is-multiline">
      {drivingSchools.map((ds) =>
        <DrivingSchool {...ds} />
      )}
    </div>
  )
}

export default DrivingSchools;